export default __webpack_public_path__ + "static/icon-nik-labeled-b-d43af2e665ad357262607124a5d8c0da.svg";